import { Expose, plainToClassFromExist, Type } from 'class-transformer';

import { SnUser } from '@lib/api/entities';

class TwilioUser {
  @Expose() public id: string;
  @Expose() public identity: string;
  @Expose() @Type(() => Date) public createdTimestamp: Date;
  @Expose() @Type(() => Date) public updatedTimestamp: Date;
  @Expose() public sid: string;
  @Expose() public user: string;

  constructor(data: any = {}) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }
}

export class SnChatUser extends SnUser {
  @Expose() @Type(() => TwilioUser) public chatUser: TwilioUser;

  @Expose() public isExternal: boolean;

  public isOnline: boolean;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }

  get sid(): string {
    return this.chatUser?.id;
  }
}
